import { processThumbSrc, processThumbSrcset } from './pg-thumbs-helpers'

const init = () => {
    if (typeof window === 'undefined') {
        return
    }

    document.addEventListener('lazybeforeunveil', (e: Event) => {
        const target = e.target as HTMLImageElement & { _lazysizesWidth: number }
        const width = target._lazysizesWidth
        if (!width) {
            return
        }
        const { src } = target.dataset
        if (!src) {
            return
        }

        target.dataset.src = processThumbSrc(src, width)
        target.dataset.srcset = processThumbSrcset(src, width)
    })
}

init()
